// Mock data for Ayush Spa website

export const siteInfo = {
  name: "Ayush SPA",
  phone: "9663222891",
  email: "ayushjpnagar@gmail.com",
  location: "Shop No. 03, Slv Complex 4th Floor, Navodaya Nagar Bus stand,Kottnpur Dinne Main Road, Jp Nagar 7th phase, Bengaluru-560078, Karnataka"
};

export const heroSlides = [
  {
    id: 1,
    title: "Each therapy is delivered in hygienic environment to ensure maximum comfort",
    subtitle: "Experience",
    image: "/gallary/aaa.jpg",
  },
  {
    id: 2,
    title: "Our treatments are curated to relax the body, revive the mind, and replenish the soul",
    subtitle: "Experience",
    image: "https://images.unsplash.com/photo-1603077864615-538e955d1ad1?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDk1NzZ8MHwxfHNlYXJjaHwzfHxsdXh1cnklMjBzcGF8ZW58MHx8fHwxNzYzNjQ4MjY3fDA&ixlib=rb-4.1.0&q=85"
  },
  {
    id: 3,
    title: "Step into a realm of relaxation, rejuvenation, and holistic healing",
    subtitle: "Experience",
    image: "https://images.pexels.com/photos/34765103/pexels-photo-34765103.jpeg"
  }
];

export const whyChooseUs = [
  { id: 1, title: "Professional and Certified Therapists", icon: "UserCheck" },
  { id: 2, title: "Premium Oils and Organic Ingredients", icon: "Droplets" },
  { id: 3, title: "Spacious and Ambience-rich Treatment Rooms", icon: "Home" },
  { id: 4, title: "Tailored Therapies to Match Your Needs", icon: "Heart" },
  { id: 5, title: "Hygiene and Privacy as Top Priority", icon: "Shield" }
];

export const services = [
  {
    id: 1,
    slug: "thai-dry-massage",
    title: "Thai Dry Massage",
    description: "Experience the therapeutic essence of Thailand with our Thai Dry Massage at Ayush Spa.",
    image: "https://images.unsplash.com/photo-1519823551278-64ac92734fb1?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2Njd8MHwxfHNlYXJjaHwxfHxtYXNzYWdlJTIwdGhlcmFweXxlbnwwfHx8fDE3NjM2NDgyNzJ8MA&ixlib=rb-4.1.0&q=85"
  },
  {
    id: 2,
    slug: "aroma-massage",
    title: "Aroma Massage",
    description: "Our Aroma Massage is a sensory delight that combines the benefits of massage therapy with the healing properties of essential oils",
    image: "https://images.unsplash.com/photo-1639162906614-0603b0ae95fd?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2Njd8MHwxfHNlYXJjaHwyfHxtYXNzYWdlJTIwdGhlcmFweXxlbnwwfHx8fDE3NjM2NDgyNzJ8MA&ixlib=rb-4.1.0&q=85"
  },
  {
    id: 3,
    slug: "swedish-massage",
    title: "Swedish Massage",
    description: "The Swedish Massage at Ayush SPA is a classic full-body treatment known for its ability to deeply relax the muscles.",
    image: "https://images.unsplash.com/photo-1515377905703-c4788e51af15?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2Njd8MHwxfHNlYXJjaHw0fHxtYXNzYWdlJTIwdGhlcmFweXxlbnwwfHx8fDE3NjM2NDgyNzJ8MA&ixlib=rb-4.1.0&q=85"
  },
  {
    id: 4,
    slug: "balinese-massage",
    title: "Balinese Massage",
    description: "Transport yourself to the island of Bali with our deeply therapeutic Balinese Massage.",
    image: "https://images.pexels.com/photos/275768/pexels-photo-275768.jpeg"
  },
  {
    id: 5,
    slug: "deep-tissue-massage",
    title: "Deep Tissue Massage",
    description: "If you suffer from chronic muscle pain or stiffness, our Deep Tissue Massage offers the perfect remedy.",
    image: "https://images.pexels.com/photos/161477/treatment-finger-keep-hand-161477.jpeg"
  },
  {
    id: 6,
    slug: "kansa-wand-massage",
    title: "Kansa Wand Massage",
    description: "The ancient wisdom of Ayurveda meets modern spa luxury in our Kansa Wand Massage.",
    image: "https://images.pexels.com/photos/34794658/pexels-photo-34794658.jpeg"
  },
  {
    id: 7,
    slug: "herbal-potli-massage",
    title: "Herbal Potli Massage",
    description: "Our Herbal Potli Massage blends warm herbal pouches with therapeutic massage to relieve muscular aches",
    image: "https://images.unsplash.com/photo-1554424518-336ec861b705?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2Nzh8MHwxfHNlYXJjaHwxfHxzcGElMjB3ZWxsbmVzc3xlbnwwfHx8fDE3NjM2NDgyNzh8MA&ixlib=rb-4.1.0&q=85"
  },
  {
    id: 8,
    slug: "hot-stone-massage",
    title: "Hot Stone Massage",
    description: "Immerse yourself in the warm embrace of our Hot Stone Massage.",
    image: "https://images.unsplash.com/photo-1544843776-7c98a52e08a4?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2Nzh8MHwxfHNlYXJjaHwzfHxzcGElMjB3ZWxsbmVzc3xlbnwwfHx8fDE3NjM2NDgyNzh8MA&ixlib=rb-4.1.0&q=85"
  },
  {
    id: 9,
    slug: "vip-room-jacuzzi",
    title: "VIP Room with Jacuzzi",
    description: "Indulge in unmatched luxury with our VIP Room featuring a private Jacuzzi.",
    image: "https://images.unsplash.com/photo-1583416750470-965b2707b355?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2Nzh8MHwxfHNlYXJjaHw0fHxzcGElMjB3ZWxsbmVzc3xlbnwwfHx8fDE3NjM2NDgyNzh8MA&ixlib=rb-4.1.0&q=85"
  },
  {
    id: 10,
    slug: "body-scrub",
    title: "Body Scrub",
    description: "Revitalize your skin with our Body Scrub therapy.",
    image: "https://images.pexels.com/photos/34799950/pexels-photo-34799950.jpeg"
  },
  {
    id: 11,
    slug: "body-polish",
    title: "Body Polish",
    description: "Our Body Polish treatment offers a luxurious experience that deeply hydrates and nourishes your skin.",
    image: "https://images.pexels.com/photos/34765103/pexels-photo-34765103.jpeg"
  }
];

export const galleryImages = [
  "gallary/4.jpeg",
  "gallary/2.jpeg",
  "gallary/1.jpeg",
  "gallary/3.jpeg",
  "gallary/5.jpeg",
  "gallary/6.jpeg",
  "gallary/7.jpeg",
  "gallary/9.jpeg",
];

export const aboutContent = {
  welcome: {
    title: "Welcome To Ayush Spa",
    subtitle: "The Luxury Spa",
    description: [
      "Welcome to Ayush Spa, your sanctuary of tranquility nestled in the heart of JP Nagar, Bengaluru. We invite you to step away from the chaos of everyday life and into a realm of relaxation, rejuvenation, and holistic healing. Our spa is designed to offer you a luxurious escape where ancient wellness traditions meet modern comforts.",
      "At Aayush Spa, we believe wellness is a way of life. Our treatments are curated to relax the body, revive the mind, and replenish the soul. Whether you're seeking relief from stress, chronic muscle tension, or simply wish to indulge in self-care, our team of experienced therapists is here to guide you through a personalized spa journey.",
      "We offer a wide range of services including Thai Dry Massage, Aroma Massage, Swedish Massage, Balinese Massage, Deep Tissue Massage and Body Scrub. Each therapy is delivered in a serene and hygienic setting to ensure maximum comfort and safety."
    ],
    image: "https://images.unsplash.com/photo-1762631203805-88841687ab4d?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDk1ODB8MHwxfHNlYXJjaHwxfHxzcGElMjBhdG1vc3BoZXJlfGVufDB8fHx8MTc2MzY0ODI4M3ww&ixlib=rb-4.1.0&q=85"
  },
  about: {
    title: "About Us Ayush Spa",
    description: [
      "At Ayush Spa, we are committed to offering a healing experience that goes beyond physical relaxation. Established with the vision to promote holistic wellness in an upscale setting, Aayush Spa stands as a symbol of indulgence, balance, and self-care.",
      "Our mission is to restore the harmony between the body and mind through therapies rooted in ancient traditions and enriched with modern spa innovations. Every service we offer is a thoughtfully crafted journey, tailored to meet the unique needs of each guest.",
      "Our therapists are certified, trained, and bring a blend of expertise and empathy to each session. We use only the finest oils, herbs, and massage techniques to ensure you receive the highest quality treatment with long-lasting benefits."
    ],
    image: "https://images.unsplash.com/photo-1761621711779-faf78317babd?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDk1ODB8MHwxfHNlYXJjaHwyfHxzcGElMjBhdG1vc3BoZXJlfGVufDB8fHx8MTc2MzY0ODI4M3ww&ixlib=rb-4.1.0&q=85"
  }
};
